import { taskApi } from 'api';

export const getDocumentsToDistributeApi = async (brId: string) => {
  return await taskApi.getDocumentsToDistribute({ brId });
};
